import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import { HelpersService } from '@/shared/services/helpers.service';
import { RelationshipManagerDashboardService } from '../../relationship-manager-dashaboard.service';
import { RelationshipManagerSummaryDto } from '../../data-access/relationship-manager-dashboard.model';
import {
    StatsSummaryCardComponent,
    StatsSummaryCardData,
} from '@/shared/ui-components/stats-summary-card/stats-summary-card.component';

@Component({
    standalone: true,
    selector: 'app-rm-stats-widget',
    imports: [CommonModule, StatsSummaryCardComponent],
    templateUrl: './rm-statswidget.html',
})
export class RmStatsWidget implements OnInit {
    public profileData = signal<RelationshipManagerSummaryDto | null>(null);
    public profileLoading = signal<boolean>(false);

    public readonly statsCards = computed<StatsSummaryCardData[]>(() => {
        const data = this.profileData();
        const loading = this.profileLoading();

        return [
            {
                id: 'live-deals',
                title: 'RM.DASHBOARD.STATS.LIVE_DEALS',
                icon: './icons/total_deal.svg',
                loading,
                value: data?.liveDeals ?? null,
            },
            {
                id: 'clients-on-platform',
                title: 'RM.DASHBOARD.STATS.CLIENTS_ON_PLATFORM',
                icon: './icons/clients.svg',
                loading,
                value: data?.clientsOnPlatform ?? null,
            },
            {
                id: 'deals-shared',
                title: 'RM.DASHBOARD.STATS.DEALS_SHARED',
                icon: './icons/total_deal.svg',
                loading,
                value: data?.dealsShared ?? null,
            },
            {
                id: 'expressed-interest',
                title: 'RM.DASHBOARD.STATS.EXPRESSED_INTEREST',
                icon: './icons/submit-interest.svg',
                valueMode: 'currency',
                loading,
                skeletonWidth: '90px',
                currencyValue: data?.expressedInterestAmount ?? null,
                currencyCode: 'USD',
                currencyCompact: true,
            },
        ];
    });

    private readonly _relationshipManagerDashboardService = inject(RelationshipManagerDashboardService);
    private readonly _helperService = inject(HelpersService);

    public ngOnInit(): void {
        this.getProfile();
    }

    private getProfile(): void {
        this.profileLoading.set(true);
        this._relationshipManagerDashboardService
            .getRelationshipManagerSummary()
            .pipe(finalize(() => this.profileLoading.set(false)))
            .subscribe({
                next: (res) => this.profileData.set(res),
                error: (err) => this._helperService.showErrorMessage(err),
            });
    }
}
